module.exports = __webpack_public_path__ + "static/media/banner-participe.b850e510.png";